var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIL02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 22",
    style: {
      enableBackground: "new 0 0 22 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.5,21c0.3,0,0.6-0.1,0.9-0.3c0.7-0.5,0.8-1.5,0.4-2.1L13.3,11l5.4-7.6c0.5-0.7,0.3-1.7-0.4-2.1 c-0.7-0.5-1.7-0.3-2.1,0.4l-6.1,8.5c-0.4,0.5-0.4,1.3,0,1.8l6.1,8.5C16.5,20.8,17,21,17.5,21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.6,21c0.3,0,0.6-0.1,0.9-0.3c0.7-0.5,0.8-1.5,0.4-2.1L6.4,11l5.4-7.6c0.5-0.7,0.3-1.7-0.4-2.1 C10.8,0.8,9.9,1,9.4,1.6l-6.1,8.5c-0.4,0.5-0.4,1.3,0,1.8l6.1,8.5C9.7,20.8,10.1,21,10.6,21z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIL02);
export default __webpack_public_path__ + "static/media/i-L02.79524b9d1ea9f4fcd5efdca47c45f8b8.svg";
export { ForwardRef as ReactComponent };